export const MILISECONDS_IN_ONE_SECOND = 1000;
export const MINUTE = MILISECONDS_IN_ONE_SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;
